

export class VueOtherDocumentLoaderScreenData {
    
    availableTypes: Array<string>;
    docTypesDialog: boolean;
    obtainedTypes: Array<string>;
    loadingSave: boolean;
    companyFolders: Array<any>;
    saldo: number;

    constructor(){
        this.availableTypes = []
        this.docTypesDialog = false
        this.obtainedTypes = []
        this.loadingSave = false
        this.companyFolders = []
        this.saldo = null
    }

    setAvailableTypes(value: Array<string>) {
        this.availableTypes = value
    }

    setObtainedTypes(value: Array<string>) {
        this.obtainedTypes = value
    }
    
}